<template>
    <transition-group
            name="list"
            tag="div"
            class="notifications-list">
        <notification-message
                v-for="notification of notifications"
                :key="notification.id"
                :message="notification.message"
                :type="notification.type.name"
                @close="removeNotification(notification.id)">
        </notification-message>
    </transition-group>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'Notifications',

        components: {
            NotificationMessage: () => import('@/components/controls/NotificationMessage')
        },

        computed: {
            ...mapGetters(['notifications'])
        },

        methods: {
            ...mapActions(['removeNotification']),
        }
    }
</script>

<style lang="scss" scoped>
    .notifications-list {
        z-index: 10;
        position: fixed;
        top: 40px;
        left: 50%;
        transform: translate(-50%, 50%);
    }
</style>


// WEBPACK FOOTER //
// src/components/controls/Notifications.vue